document.addEventListener("DOMContentLoaded", function () {
  const offerBox = document.querySelector(".offer-box");
  if (!offerBox) return;

  const price = parseFloat(offerBox.dataset.price);
  if (isNaN(price)) return;

  let discount = 0;
  let couponCode = "";

  if (price > 1200) {
    discount = 0.15;
    couponCode = "ECELL15";
  } else if (price > 600) {
    discount = 0.1;
    couponCode = "ECELL10";
  } else if (price > 300) {
    discount = 0.05;
    couponCode = "ECELL5";
  }

  let discounted = price - price * discount;
  discounted -= discounted * 0.05; // extra prepaid discount

  document.getElementById(
    "discounted-price"
  ).innerText = `₹${discounted.toFixed(2)}`;
  document.getElementById("original-price").innerText = `₹${price.toFixed(2)}`;
  document.getElementById("applied-coupon").innerText = couponCode;
  document.getElementById("copy-btn").setAttribute("data-code", couponCode);
});

function copyCoupon() {
  const code = document.getElementById("copy-btn").getAttribute("data-code");
  navigator.clipboard.writeText(code).then(function () {
    const btn = document.getElementById("copy-btn");
    btn.innerText = "Copied!";
    setTimeout(() => {
      btn.innerText = "Copy";
    }, 1500);
  });
}
